export enum AddResourceSearchType {
  DISCOVERY = 'discovery',
  NBD_BOOK_SEARCH = 'nbdBookSearch',
  OFF = 'off',
}
